import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkConsentStatus } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';
import ThemedSpinner from './ThemedSpinner';
//import ConsentError from './ConsentError';

const ConsentTransfer = (props) => {
  const dispatch = useDispatch();
  const { institution, consent_guid, redirect_url, theme } = props;

  useEffect(() => {
    if (!institution) {
      return;
    }

    const pollConsentStatus = async () => {
      try {
        await dispatch(checkConsentStatus(consent_guid, institution));
      } catch (err) {
      }
    };

    const intervalId = setInterval(pollConsentStatus, 7000);
    return () => clearInterval(intervalId);
  }, [dispatch, consent_guid, institution]);

  useEffect(() => {
    if (redirect_url && institution) {
      const timer = setTimeout(() => {
        const slug = institution.slug || institution.name || consent_guid;
        dispatch(postMessageSuccess("awaiting_consent", {slug: slug}));
        window.open(redirect_url, '_blank');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [dispatch, redirect_url, institution, consent_guid]);

  if (!institution) {
    return <ThemedSpinner theme={theme} />;
  }

  return (
    <div id="intro">
      <div className="consent-data-wrapper transfer-to-provider">
        <h2 className="form-group text-center">
          Transferring you to <strong>{institution.name}</strong>
        </h2>
        <ThemedSpinner theme={theme} />
        <div className="form-group text-center">
          <p>We are redirecting you to the {institution.name} where you will login securely before viewing and authorising this request.</p>
        </div>
      </div>
    </div>
  );
};

export default ConsentTransfer;